import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { mockServiceListReducer } from 'store/mockServices/mockServiceList/mockServiceListReducer';
import { mockServiceDetailsReducer } from 'store/mockServices/mockServiceDetail/mockServiceDetailReducer';
import { TransactionListState } from 'store/transactions/transactionsTypes';
import { BlazeUserConfigState } from 'store/blazeUserConfig/blazeUserConfigTypes';
import { transactionReducer } from 'store/transactions/transactionsReducer';
import uiReducer, { UiState } from 'store/ui/uiReducer';
import { serviceReducer } from 'store/services/servicesReducer';
import blazeUserConfigReducer from 'store/blazeUserConfig/blazeUserConfigReducer';
import { TransactionsDropzoneReducer } from 'store/transactionDropzone/transactionDropzoneReducer';
import { TransactionsDropzoneState } from 'store/transactionDropzone/transactionDropzoneTypes';
import {
  mockServiceTemplatesReducer,
  MockServiceTemplatesState,
} from './mockServiceTemplates/mockServiceTemplateReducer';
import { ServicesState } from 'store/services/servicesTypes';
import { MarFilesState } from 'types/rest/marFilesTypes';
import { marFilesReducer } from 'store/marFiles/marFilesReducer';
import { MockServiceState } from 'store/mockServices/mockServiceTypes';
import { MockServiceDetailsState } from 'store/mockServices/mockServiceDetail/mockServiceDetailTypes';
import {
  mockServiceTemplateDetailReducer,
  MockServiceTemplateDetailState,
} from 'store/mockServiceTemplates/mockServiceTemplateDetail/mockServiceTemplateDetailReducer';
import { AnalyticsUiState } from 'store/analytics/ui/analyticsUiTypes';
import { analyticsUiReducer } from 'store/analytics/ui/analyticsUiReducer';
import { AnalyticsDataState } from 'store/analytics/data/analyticsDataTypes';
import { analyticsDataReducer } from 'store/analytics/data/analyticsDataReducer';
import { sharedFoldersReducer } from './sharedFolders/sharedFoldersReducer';
import { SharedFoldersState } from './sharedFolders/sharedFoldersTypes';
import { dataModelReducer } from './dataModel/dataModelReducer';
import { DataModelState } from './dataModel/dataModelTypes';
import { CertificatesState } from './certificates/certificatesTypes';
import { certificatesReducer } from './certificates/certificatesReducer';
import { ConfigurationsState } from './configurations/configurationsTypes';
import { configurationsReducer } from './configurations/configurationsReducer';
import { mockServiceGroupReducer } from './mockServiceGroups/mockServiceGroupReducer';
import { MockServiceGroupState } from './mockServiceGroups/mockServiceGroupTypes';
import { trackingsReducer } from './trackings/trackingsReducer';
import { RecordingsState } from './recordings/recordingsTypes';
import { recordingsReducer } from './recordings/recordingsReducer';
import { recordingMessageReducer } from './recordings/recordingMessages/recordingMessagesReducer';
import { RecordingMessagesState } from './recordings/recordingMessages/recordingMessagesTypes';
import { SecretsVaultState } from './secrets/secretsTypes';
import { secretsVaultReducer } from './secrets/secretsVaultReducer';
import { aiConversationsReducer } from './aiConversations/aiConversationsReducer';
import { AiConversationsState } from './aiConversations/aiConversationsTypes';
import blueprintsReducer from './blueprints/blueprintsReducer';
import { BlueprintsState } from './blueprints/blueprintsTypes';

// Top level state object
export interface ApplicationState {
  transactionsDropzone: TransactionsDropzoneState;
  mockservices: MockServiceState;
  transactions: TransactionListState;
  mockServiceDetailsServiceTransactions: TransactionListState;
  mockServiceDetailsServiceMockTransactions: TransactionListState;
  blazeUserConfig: BlazeUserConfigState;
  ui: UiState;
  services: ServicesState;
  mockServiceDetails: MockServiceDetailsState;
  mockServiceTemplates: MockServiceTemplatesState;
  mockServiceTemplateDetail: MockServiceTemplateDetailState;
  mockServiceGroup: MockServiceGroupState;
  routing: any;
  marFiles: MarFilesState;
  analytics: { ui: AnalyticsUiState; data: AnalyticsDataState };
  sharedFolders: SharedFoldersState;
  dataModel: DataModelState;
  certificates: CertificatesState;
  configurations: ConfigurationsState;
  secretsVault: SecretsVaultState;
  recordings: RecordingsState;
  recordingMessages: RecordingMessagesState;
  aiConversations: AiConversationsState;
  blueprints: BlueprintsState;
}

// Reducers combined as any due to: https://github.com/reduxjs/redux/issues/2709
export const rootReducer = combineReducers({
  transactionsDropzone: TransactionsDropzoneReducer,
  mockservices: mockServiceListReducer,
  mockServiceTemplates: mockServiceTemplatesReducer,
  transactions: transactionReducer,
  blazeUserConfig: blazeUserConfigReducer,
  ui: uiReducer,
  services: serviceReducer,
  mockServiceDetails: mockServiceDetailsReducer,
  mockServiceTemplateDetail: mockServiceTemplateDetailReducer,
  mockServiceGroup: mockServiceGroupReducer,
  routing: routerReducer,
  marFiles: marFilesReducer,
  analytics: combineReducers({ ui: analyticsUiReducer, data: analyticsDataReducer } as any),
  sharedFolders: sharedFoldersReducer,
  dataModel: dataModelReducer,
  certificates: certificatesReducer,
  configurations: configurationsReducer,
  secretsVault: secretsVaultReducer,
  trackings: trackingsReducer,
  recordings: recordingsReducer,
  recordingMessages: recordingMessageReducer,
  aiConversations: aiConversationsReducer,
  blueprints: blueprintsReducer,
} as any);
